import * as v from 'valibot';

export const paginated = <
  const TWrapped extends v.BaseSchema<unknown, unknown, v.BaseIssue<unknown>>,
>(
  wrapped: TWrapped,
) =>
  v.object({
    count: v.nullish(v.number(), () => undefined),
    next: v.nullish(v.string(), () => undefined),
    previous: v.nullish(v.string(), () => undefined),
    results: v.array(wrapped),
  });

const StringAsNumber = v.pipe(v.string(), v.toNumber());

/** Creates a `numeric` schema that can accept a string or a number and returns a number. */
export const numeric = () => v.union([StringAsNumber, v.number()]);

export const MetricsSchema = v.objectWithRest(
  { calculated_at: v.string() },
  v.union([v.number(), v.string(), v.boolean(), v.null()]),
);

export type Metrics = v.InferOutput<typeof MetricsSchema>;

export const WebRecIdSchema = v.pipe(numeric(), v.brand('WebRecId'));
export type WebRecId = v.InferOutput<typeof WebRecIdSchema>;

export const OfferIdSchema = v.pipe(v.number(), v.brand('OfferId'));
export type OfferId = v.InferOutput<typeof OfferIdSchema>;

export const LoanApplicationIdSchema = v.pipe(v.number(), v.brand('LoanApplicationId'));
export type LoanApplicationId = v.InferOutput<typeof LoanApplicationIdSchema>;

export const LoanCaseIdSchema = v.pipe(v.number(), v.brand('LoanCaseId'));
export type LoanCaseId = v.InferOutput<typeof LoanCaseIdSchema>;

export const ApplicationInternalIdSchema = v.pipe(v.number(), v.brand('ApplicationInternalId'));
export type ApplicationInternalId = v.InferOutput<typeof ApplicationInternalIdSchema>;

export const AccountIdSchema = v.pipe(v.string(), v.brand('AccountId'));
export type AccountId = v.InferOutput<typeof AccountIdSchema>;

export type ConsentClusterSlug = `cc-${string}`;
export type ConsentKindSlug = `ck-${string}`;

export const ConsentClusterSlugSchema = v.pipe(
  v.string(),
  v.startsWith('cc-'),
  v.transform((s) => s as ConsentClusterSlug),
);

export const ConsentKindSlugSchema = v.pipe(
  v.string(),
  v.startsWith('ck-'),
  v.transform((s) => s as ConsentKindSlug),
);

export const ProductTypeSchema = v.picklist(['CREDIT_CARD', 'REFINANCING', 'CONSUMER_LOAN']);
export type ProductType = v.InferOutput<typeof ProductTypeSchema>;
